<app-environment-decorator></app-environment-decorator>

<main class="Root">
  <router-outlet />
</main>
